import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";

/**
 * Returns the current user's city from their profile, or null if not
 * available (not logged in, no city saved, or still loading).
 */
export function useUserCity(): string | null {
  const [city, setCity] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      const { data: { session } } = await supabase.auth.getSession();
      const uid = session?.user?.id;
      if (!uid) return;
      const { data } = await supabase
        .from("profiles")
        .select("city")
        .eq("id", uid)
        .maybeSingle();
      if (!cancelled && data?.city) setCity(data.city);
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  return city;
}
